import constantes from "../../constantes";
export default {
    state: {
        actual: null,
        data:{

        },
    },
    mutations: {
        setActual (state, paso) {
            state.actual = paso;
        },
        setPaso (state, dto) {
            state.data[dto.p]=dto.data;
        },
        limpiar (state) {
            state.data={};
            //state.actual=1;
        }
    },
    getters: {
        getNumData:state => {
            return Object.keys(state.data).length;
        },
        getLisPasos: state => {
            return (state.pasos);
        },
        getActual: state => {
            return (state.actual);
        },
        getPasos:state => {
            return (state.data);
        },
        getPasoActual: state=>{
            function buscar (numero){
                for (let i=0; i < constantes.Constantes.pasos.length; i++) {
                    if (constantes.Constantes.pasos[i].numero === numero) {
                        return constantes.Constantes.pasos[i];
                    }
                }
            }
            return (buscar(state.actual));
        }
    }

}
